module.exports = "/_next/static/images/Hero@2x-efd33c8043281e83d700f87ebf8c2115.png";